module.exports = __webpack_public_path__ + "static/media/USC Sample Planning Station.f34622c8.pdf";